import React, { ReactNode } from "react";
import { Navigate } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "../store";

interface PrivateRouteProps {
  allowedRoles: string[];
  children: ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  allowedRoles,
  children,
}) => {
  const { user, isAuthenticated, isLoading } = useSelector(
    (state: RootState) => state.auth,
  );

  if (isLoading) return null;

  if (!isAuthenticated) {
    return <Navigate to={`/login`} replace />;
  }

  if (user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
